import { render, staticRenderFns } from "./ModalApprovedOrRejectDocument.vue?vue&type=template&id=e93cb484&"
import script from "./ModalApprovedOrRejectDocument.vue?vue&type=script&lang=ts&"
export * from "./ModalApprovedOrRejectDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports